import React from 'react';
import { useTranslation } from 'react-i18next';
import { DeepMap, FieldError, FieldValues } from 'react-hook-form';
import ErrorMessageWrapper from '../ErrorMessageWrapper';

interface PropTypes {
  errors: DeepMap<FieldValues, FieldError>;
  errorMessage?: string;
}

const ErrorMessage: React.FC<PropTypes> = ({ errors, errorMessage }) => {
  const { t } = useTranslation(['signin', 'formError']);

  return (
    <ErrorMessageWrapper>
      {(() => {
        if (errors.password && errors.password.type) {
          return (
            <>
              {t('signin:password')}
              {t('formError:required')}
            </>
          );
        }
        if (errorMessage) {
          return <>{errorMessage}</>;
        }
        return <></>;
      })()}
    </ErrorMessageWrapper>
  );
};

export default ErrorMessage;
